import React from 'react';
import { Menu as MuiMenu, MenuItem } from '@mui/material';
import {
  User,
  Calendar,
  Briefcase,
  BadgeCheck,
  XCircle,
  MessageSquare,
  FileText,
  Edit3,
} from 'lucide-react';

interface RecruiterActionMenuProps {
  anchorEl: HTMLElement | null;
  handleCloseMenu: () => void;
  currentMenuCandidate: any;
  handleOfferStageChange: (id: string, stage: 'CONTACTED' | 'INTERVIEW' | 'PROBATION' | 'HIRED' | 'REJECTED') => void;
  handleStartChat: () => void;
  setSelectedDetailCandidate: (candidate: any) => void;
  setNoteCandidate: (candidate: any) => void;
}

/**
 * Menu Thao Tác 3 Chấm Dành Cho Bảng Dữ Liệu Ứng Viên
 * Chứa các nút cập nhật tiến độ (Liên hệ, Phỏng vấn, Thử việc, Tuyển dụng, Từ chối), Nhắn tin, Xem chi tiết & Ghi chú.
 */
export const RecruiterActionMenu: React.FC<RecruiterActionMenuProps> = ({
  anchorEl,
  handleCloseMenu,
  currentMenuCandidate,
  handleOfferStageChange,
  handleStartChat,
  setSelectedDetailCandidate,
  setNoteCandidate,
}) => {
  return (
    <MuiMenu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCloseMenu}
      sx={{
        borderRadius: '16px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        border: '1px solid #f1f3f5',
        p: 0.5,
        minWidth: 160,
      }}
    >
      {currentMenuCandidate && (
        <div className="text-xs font-bold text-gray-600">
          {/* Cập nhật quy trình: Liên hệ */}
          <MenuItem
            onClick={() =>
              currentMenuCandidate.isReal
                ? handleOfferStageChange(currentMenuCandidate.id, 'CONTACTED')
                : (alert('Đã cập nhật ứng viên mock!'), handleCloseMenu())
            }
            sx={{ color: '#6366f1', fontWeight: 'bold', fontSize: '11px', py: 1, borderRadius: '8px' }}
          >
            <User size={13} className="mr-2" /> Liên hệ
          </MenuItem>

          {/* Cập nhật quy trình: Phỏng vấn */}
          <MenuItem
            onClick={() =>
              currentMenuCandidate.isReal
                ? handleOfferStageChange(currentMenuCandidate.id, 'INTERVIEW')
                : (alert('Đã cập nhật ứng viên mock!'), handleCloseMenu())
            }
            sx={{ color: '#8b5cf6', fontWeight: 'bold', fontSize: '11px', py: 1, borderRadius: '8px' }}
          >
            <Calendar size={13} className="mr-2" /> Phỏng vấn
          </MenuItem>

          {/* Cập nhật quy trình: Thử việc */}
          <MenuItem
            onClick={() =>
              currentMenuCandidate.isReal
                ? handleOfferStageChange(currentMenuCandidate.id, 'PROBATION')
                : (alert('Đã cập nhật ứng viên mock!'), handleCloseMenu())
            }
            sx={{ color: '#ec4899', fontWeight: 'bold', fontSize: '11px', py: 1, borderRadius: '8px' }}
          >
            <Briefcase size={13} className="mr-2" /> Thử việc
          </MenuItem>

          {/* Cập nhật quy trình: Tuyển dụng (Hired) */}
          <MenuItem
            onClick={() =>
              currentMenuCandidate.isReal
                ? handleOfferStageChange(currentMenuCandidate.id, 'HIRED')
                : (alert('Đã cập nhật ứng viên mock!'), handleCloseMenu())
            }
            sx={{ color: '#10b981', fontWeight: 'bold', fontSize: '11px', py: 1, borderRadius: '8px' }}
          >
            <BadgeCheck size={13} className="mr-2" /> Tuyển dụng (Hired)
          </MenuItem>

          {/* Cập nhật quy trình: Từ chối */}
          <MenuItem
            onClick={() =>
              currentMenuCandidate.isReal
                ? handleOfferStageChange(currentMenuCandidate.id, 'REJECTED')
                : (alert('Đã từ chối ứng viên mock!'), handleCloseMenu())
            }
            sx={{ color: '#ef4444', fontWeight: 'bold', fontSize: '11px', py: 1, borderRadius: '8px' }}
          >
            <XCircle size={13} className="mr-2" /> Từ chối
          </MenuItem>

          <div className="h-px bg-gray-100 my-1" />

          {/* Nhắn tin trực tiếp */}
          <MenuItem onClick={handleStartChat} sx={{ fontSize: '11px', py: 1, borderRadius: '8px', fontWeight: 'bold' }}>
            <MessageSquare size={13} className="mr-2 text-gray-400" /> Nhắn tin trao đổi
          </MenuItem>

          {/* Xem hồ sơ chi tiết */}
          <MenuItem
            onClick={() => {
              setSelectedDetailCandidate(currentMenuCandidate);
              handleCloseMenu();
            }}
            sx={{ fontSize: '11px', py: 1, borderRadius: '8px', fontWeight: 'bold' }}
          >
            <FileText size={13} className="mr-2 text-gray-400" /> Xem chi tiết
          </MenuItem>

          {/* Thêm/Sửa ghi chú cho ứng viên */}
          <MenuItem
            onClick={() => {
              setNoteCandidate(currentMenuCandidate);
              handleCloseMenu();
            }}
            sx={{ fontSize: '11px', py: 1, borderRadius: '8px', fontWeight: 'bold', color: '#f97316' }}
          >
            <Edit3 size={13} className="mr-2 text-inherit" /> Ghi chú
          </MenuItem>
        </div>
      )}
    </MuiMenu>
  );
};

export default RecruiterActionMenu;
